// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAQWxtMWbNF2z0qrT78BOO7VykuCuNH61Y',
    authDomain: 'auction-mongers.firebaseapp.com',
    databaseURL: '<your-database-URL>',
    projectId: 'auction-mongers',
    storageBucket: 'auction-mongers.appspot.com',
    messagingSenderId: '718418143264',
    appId: '1:718418143264:web:6f76f31ac339d52d22b445',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
